module.exports = __webpack_public_path__ + "static/media/tebeznam.420d8fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/tebeznam.png
// module id = 694
// module chunks = 0